import React from "react";
import barcode from "../../images/barcode.png";

const footer = () => {
  return (
    <div className="fq-bac-2">
      <div className="container">
        <div className="landing-row flex lg:flex-row flex-col">
          <div>
            <h4 className="footer-header whitespace-nowrap text-justify">
              Join the waitlist
            </h4>
            <p className="footer-sentence w-full lg:w-[80%]">
              Be the first to hear; and then get ahead when we lunch our Mobile
              App Parked with all the exciting features! 💥🫰
            </p>
          </div>

          <div className="">
            <img src={barcode} className="img-fluid barcode w-[80%] mt-6 lg:w-[50%] md:w-[70%] lg: mt-[110px]" alt="barcode" />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="line"></div>
        <div className="row">
          <div className="col">
            <h6 className="footer-h-1">Company</h6>

            <li>About</li>
            <li>News</li>
            <li>Careers</li>
          </div>

          <div className="col">
            <h6 className="footer-h-1">Community</h6>

            <li>Support</li>
            <li>Community Guidelines</li>
            <a href="https://www.instagram.com/cuppybetafrica/">
              <li className="active-footer">Instagram</li>
            </a>
          </div>

          <div className="col">
            <h6 className="footer-h-1">Legal</h6>

            <li>Terms & conditions</li>
          </div>

          <div className="col">
            <p class="copy-right-cuppy">
              2024 Cuppycode.com | All rights reserved{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default footer;
